<template>
  <Teleport to="body">
    <div v-if="modelValue" class="fixed inset-0 z-[70] overflow-y-auto">
      <div class="fixed inset-0 bg-black/50" @click="close"></div>
      <div class="relative flex min-h-screen items-center justify-center p-4">
        <div class="relative flex max-h-[92vh] w-full max-w-md flex-col overflow-hidden rounded-lg bg-white shadow-xl">
          <header class="flex items-start justify-between gap-4 border-b border-slate-200 px-6 py-4">
            <div>
              <h3 class="text-lg font-semibold text-slate-900">{{ modalTitle }}</h3>
            </div>
            <button
              type="button"
              class="rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600"
              @click="close"
            >
              <span class="sr-only">关闭</span>
              <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </header>

          <main class="px-6 py-5">
            <label class="block">
              <span class="form-label">区域名称 <span class="text-red-500">*</span></span>
              <input
                v-model="form.regionName"
                type="text"
                class="form-input mt-1 w-full"
                placeholder="请输入区域名称"
                @keyup.enter="submit"
              >
            </label>
          </main>

          <footer class="flex justify-end gap-3 border-t border-slate-200 px-6 py-4">
            <button type="button" class="btn-secondary" @click="close">取消</button>
            <button type="button" class="btn-primary" v-permission="'enterprise-invoice:region:manage'" @click="submit">保存</button>
          </footer>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed, reactive, watch } from 'vue'
import { ElMessage } from 'element-plus'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  region: { type: Object, default: null }
})

const emit = defineEmits(['update:modelValue', 'submit'])

const form = reactive({ regionName: '' })

const modalTitle = computed(() => props.region?.id ? '重命名区域' : '新增区域')

function resetForm() {
  form.regionName = props.region?.regionName || ''
}

function close() {
  emit('update:modelValue', false)
}

function submit() {
  if (!form.regionName.trim()) {
    ElMessage.warning('请填写区域名称')
    return
  }
  emit('submit', {
    id: props.region?.id || null,
    regionName: form.regionName.trim()
  })
}

watch(() => props.modelValue, value => {
  if (value) resetForm()
})

watch(() => props.region, () => {
  if (props.modelValue) resetForm()
})
</script>
